import React from 'react';
import { observer } from "mobx-react";
import { WeaTextarea } from 'ecCom';

export default observer(({ path, viewAttr, placeholder, textheight, fieldName, form,style }) => {
    let maxRows=textheight;
    if(maxRows<10){
        maxRows = maxRows*2;
        if(maxRows>10){
            maxRows = 10;
        }
    }
    return (
        <WeaTextarea ecId={`${this && this.props && this.props.ecId || ''}_WeaTextarea@3hl5gy`}
            {...form.$(path).bind()}
            fieldName={fieldName}
            id={fieldName}
            name={fieldName}
            viewAttr={viewAttr}
            placeholder={placeholder}
            minRows={textheight}
            maxRows={maxRows}
            style={style}
        />
    )
})


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/excel-layout/cell-field/textarea-element/Textarea.tsx